import { combineReducers } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useSelector } from "react-redux";

import { codeBookApi } from "../queries/codeBookQuery";
import { committeeApi } from "../queries/committeeQuery";
import { institutionApi } from "../queries/dataQuery";
import { founderApi } from "../queries/founderQuery";
import { remarkApi } from "../queries/remarkQuery";
import { requestApi } from "../queries/requestQuery";
import applicationReducer from "../slices/applicationSlice";

const rootReducer = combineReducers({
  application: applicationReducer,
  [codeBookApi.reducerPath]: codeBookApi.reducer,
  [committeeApi.reducerPath]: committeeApi.reducer,
  [remarkApi.reducerPath]: remarkApi.reducer,
  [institutionApi.reducerPath]: institutionApi.reducer,
  [founderApi.reducerPath]: founderApi.reducer,
  [requestApi.reducerPath]: requestApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export default rootReducer;
